import styled from 'styled-components';

import { ArchivedRowStyle, StyledTable } from 'components/DataTable/DataTable.style';

export const StyledPopoverTable = styled(StyledTable)`
  .ant-table-row {
    background-color: ${({ theme }) => theme.secondaryBackgroundColor};
  }
`;

export const StyledTasksPopoverTable = styled(StyledTable)`
  .ant-table-row {
    background-color: ${({ theme }) => theme.secondaryBackgroundColor};
  }
  ${ArchivedRowStyle}
`;
